/**
 * Canonical product display label.
 *
 * Products are identified by SKU, and two products may share a brand and name
 * as size/package variants — so every user-facing label must include
 * variant_label or the two are indistinguishable.
 */
export function formatProductLabel(product) {
    if (!product) return '';
    const name = product.product_name || product.name || '';
    const parts = [product.brand, name].filter(Boolean);
    const label = parts.join(' - ');
    const variant = product.variant_label;
    return variant ? `${label} (${variant})` : label;
}

/** Invoice/receipt line description. Same text; named for intent. */
export function formatProductLine(product) {
    return formatProductLabel(product) || 'Product';
}

/**
 * Label for a row using the `recommended_product_*` / `actual_product_*`
 * field shape (brand/name/variant stored under a shared prefix, rather than
 * as `brand`/`product_name`/`variant_label`).
 */
export function formatPrefixedProductLabel(row, prefix) {
    if (!row) return '';
    return formatProductLabel({
        brand: row[`${prefix}_brand`],
        product_name: row[`${prefix}_name`],
        variant_label: row[`${prefix}_variant`],
    });
}
